import { render, staticRenderFns } from "./ReturnInfo.vue?vue&type=template&id=65e9b8ef&"
import script from "./ReturnInfo.vue?vue&type=script&lang=js&"
export * from "./ReturnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports